import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.393 13.593a1.457 1.457 0 00-1.459-.531c-.55.117-.98.537-1.1 1.076-.12.538.092 1.096.543 1.426l5.76 5.634c.56.537 1.456.537 2.016 0l5.76-5.634c.43-.56.373-1.345-.134-1.84a1.464 1.464 0 00-1.882-.131l-4.752 4.62-4.752-4.649v.029z",
      fill: "#B6B6BF"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.607 10.408c.338.441.908.649 1.459.532.55-.118.98-.538 1.1-1.077a1.393 1.393 0 00-.543-1.426l-5.76-5.634a1.463 1.463 0 00-2.016 0l-5.76 5.634c-.43.56-.373 1.345.134 1.84a1.464 1.464 0 001.882.131l4.752-4.62 4.752 4.649v-.029z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
